import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { Period } from "@/api/types"
import { SHORT_STALE_TIME } from "@/lib/constants"

export function tradesTotalsOptions(period: Period, companyId?: number) {
	return queryOptions({
		queryKey: ["trading", "totals", period, companyId],
		queryFn: () =>
			GET("/api/v1/trading/analytics/totals", {
				params: { query: { period, company_id: companyId } },
			}),
	})
}

export function useTradesTotals(period: Period, companyId?: number) {
	return useQuery(tradesTotalsOptions(period, companyId))
}

export function pendingSummaryOptions(companyId?: number) {
	return queryOptions({
		queryKey: ["trading", "pending-summary", companyId],
		queryFn: () =>
			GET("/api/v1/trading/analytics/pending-summary", {
				params: { query: { company_id: companyId } },
			}),
	})
}

export function usePendingSummary(companyId?: number) {
	return useQuery(pendingSummaryOptions(companyId))
}

export function openPositionsOptions() {
	return queryOptions({
		queryKey: ["trading", "open-positions"],
		queryFn: () => GET("/api/v1/trading/analytics/open-positions"),
	})
}

export function useOpenPositions() {
	return useQuery(openPositionsOptions())
}

export function awaitingSummaryOptions() {
	return queryOptions({
		queryKey: ["trading", "awaiting-summary"],
		queryFn: () => GET("/api/v1/trading/analytics/awaiting-summary"),
		staleTime: SHORT_STALE_TIME,
	})
}

export function useAwaitingSummary() {
	return useQuery(awaitingSummaryOptions())
}

export function useTradingDashboardSummary() {
	return useQuery({
		queryKey: ["trading", "dashboard-summary"],
		queryFn: () => GET("/api/v1/trading/analytics/dashboard-summary"),
	})
}
